import React from "react";
import getConfig from "next/config";
import Link from "next/link";
import FullWidthSection from "../components/FullWidthSection";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const themes = [
  {
    img: "sonic",
    value: "colectie-8837/sonic",
  },
  {
    img: "speed-champions",
    value: "colectie-8837/speed-champions",
  },
  {
    img: "super-mario",
    value: "colectie-8837/super-mario",
  },
  {
    img: "star-wars",
    value: "colectie-8837/star-wars",
  },
  {
    img: "technic",
    value: "colectie-8837/technic",
  },
  {
    img: "architecture",
    value: "colectie-8837/architecture",
  },
  {
    img: "art",
    value: "colectie-8837/art",
  },
  {
    img: "botanicals",
    value: "colectie-8837/botanicals",
  },
  {
    img: "city",
    value: "colectie-8837/city",
  },
  {
    img: "classic",
    value: "colectie-8837/classic",
  },
  {
    img: "creator-3-in-1",
    value:
      "colectie-8837/creator/varsta-8282/10-11-ani_9-10-ani_8-9-ani_7-8-ani_6-7-ani_11-12-ani",
  },
  {
    img: "disney",
    value: "colectie-8837/disney",
  },
  {
    img: "dreamzzz",
    value: "colectie-8837/dreamzzz",
  },
  {
    img: "duplo",
    value: "colectie-8837/duplo",
  },
  {
    img: "friends",
    value: "colectie-8837/friends",
  },
  {
    img: "icons",
    value: "colectie-8837/icons",
  },
  {
    img: "ideas",
    value: "colectie-8837/creator-expert_ideas",
  },
  {
    img: "marvel",
    value: "colectie-8837/marvel",
  },
  {
    img: "minecraft",
    value: "colectie-8837/minecraft",
  },

  {
    img: "ninjago",
    value: "colectie-8837/ninjago",
  },
];

const LegoByTheme = () => (
  <div className="">
    <div className="mb-8 sm:max-w-[60%] md:max-w-[35%] -ml-[8px]">
      <img
        src={`${settings.websiteStatics}/images/universul-lego/theme_title.png`}
        alt=""
      />
    </div>

    <FullWidthSection padding="p-0">
      <ul className="grid grid-rows-2 grid-flow-col overflow-x-scroll gap-4 px-4 md:grid-flow-row md:grid-rows-none md:grid-cols-4 lg:grid-cols-5">
        {themes.map(({ img, value }, index) => (
          <li key={index} className="w-40 sm:w-48 md:w-auto">
            <Link href={`/lego-jucarii/cpl/filtru/${value}/`}>
              <a title="">
                <img
                  src={`${settings.websiteStatics}/images/universul-lego/tema/${img}.png`}
                  alt=""
                />
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </FullWidthSection>
  </div>
);

export default LegoByTheme;
